import React, { forwardRef } from 'react';
import RcSlider from 'rc-slider';

import { generateMarks } from './helpers.ts';
import { SliderContainer, ValueLabel } from './styled.ts';

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  min?: number;
  step?: number;
  disabled?: boolean;
  withMarks?: boolean;
  isApplyOnAfterChange?: boolean;
  formatValueLabel?: (value: number) => string;
}

export const Slider = forwardRef<RcSlider, SliderProps>(function Slider(
  { disabled = false, min = 0, max = 100, step = 1, value, formatValueLabel, withMarks = false, onChange, isApplyOnAfterChange },
  ref,
) {
  const [stateValue, setStateValue] = React.useState(value);

  const valueLabel = React.useMemo(() => {
    const v = isApplyOnAfterChange ? stateValue : value;
    return formatValueLabel ? formatValueLabel(v) : v;
  }, [formatValueLabel, isApplyOnAfterChange, stateValue, value]);

  return (
    <>
      <ValueLabel data-testid='slider-value'>{valueLabel}</ValueLabel>
      <SliderContainer $disabled={disabled} data-value={value} data-at-min={value === min} data-at-max={value === max}>
        <RcSlider
          ref={ref}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          value={isApplyOnAfterChange ? stateValue : value}
          onChange={isApplyOnAfterChange ? (v) => setStateValue(v) : onChange}
          onAfterChange={isApplyOnAfterChange ? onChange : undefined}
          marks={withMarks ? generateMarks(min, max, step) : undefined}
        />
      </SliderContainer>
    </>
  );
});

Slider.displayName = 'Slider';
